import React, { useState, useEffect } from "react";

import {fetchStockRiskVol, fetchStockTechnicals} from "../../api";

import Plot from "react-plotly.js";
import Stockchart from "../stockchart_plotly";

const HistoricalVol = ({ data }) => {
  console.log("VOL",data.volatility);
  return (
      <Plot
        data={[
          {
            x: data.volatility.map(d => d.Date),
            y: data.volatility.map(d => d.Volatility),
            type: "scatter",
            mode: "lines",
            name: "Historical Volatility",
            line: { color: "blue" },
          },
        ]}
        layout={{ title: "Historical Volatility (Rolling 30-Day)", xaxis: { title: "Time" }, yaxis: { title: "Volatility" } }}
        style={{ width: '100%', height: '100%' }}  // Full width/height of container
      />
  );
};

const BetaCorr = ({ data }) => {
  return (
      <Plot
        data={[
          {
            x: data.scatter_data.index_returns,
            y: data.scatter_data.stock_returns,
            type: "scatter",
            mode: "markers",
            name: "Stock vs. NIFTY",
            marker: { color: "red" },
          },
        ]}
        layout={{
          title: `Beta & Correlation (Beta: ${data.beta})`,
          xaxis: { title: "NIFTY Returns" },
          yaxis: { title: "Stock Returns" },
        }}
        style={{ width: '100%', height: '100%' }}  // Full width/height of container
      />
  );
};

const Drawdowns = ({ data }) => {
  return (
      <Plot
        data={[
          {
            x: data.drawdowns.map(d => d.Date),
            y: data.drawdowns.map(d => d.Drawdown),
            type: "scatter",
            mode: "lines",
            fill: "tozeroy",
            name: "Drawdowns",
            line: { color: "pink" },
          },
        ]}
        layout={{ title: "Stock Drawdowns", xaxis: {}, yaxis: { title: "Drawdown (%)" } }}
        style={{ width: '100%', height: '100%' }}  // Full width/height of container
      />
  );
};

const ImpVol = ({ data }) => {
  const data1 = JSON.parse(data.iv_surface);
  if (!data1.strikes) return <p>Not an F&O stock</p>;
  return (
      <Plot
        data={[
          {
            type: "surface",
            // x: data.iv_surface.strikes,
            x: data1.strikes,
            // y: data.iv_surface.expiries,
            y: data1.expiries,
            // z: data.iv_surface.iv_values,
            z: data1.iv_values,
            colorscale: "Viridis",
            hovertemplate: "Strike: %{x}<br>Time to Expiry: %{y} <br>Implied Vol: %{z:.2f}<extra></extra>",

          },
        ]}
        layout={{ title: "Implied Volatility Surface", scene: { xaxis: { title: "Strikes" }, yaxis: { title: "Days to Expiry" }, zaxis: { title: "Implied Volatility" } } }}
        style={{ width: '100%', height: '100%' }}  // Full width/height of container
      />
  );
};


// const MomentumIndicators = ({ data }) => {
//   return (
//     <Plot
//       data={[
//         {
//           x: data.rsi.map((_, i) => i),
//           y: data.rsi,
//           type: "scatter",
//           mode: "lines",
//           name: "RSI",
//           line: { color: "purple" },
//         },
//         {
//           x: data.macd.map((_, i) => i),
//           y: data.macd,
//           type: "scatter",
//           mode: "lines",
//           name: "MACD",
//           line: { color: "green" },
//         },
//         {
//           x: data.signal.map((_, i) => i),
//           y: data.signal,
//           type: "scatter",
//           mode: "lines",
//           name: "Signal Line",
//           line: { color: "red" },
//         },
//       ]}
//       layout={{ title: "Momentum Indicators (RSI, MACD)", xaxis: { title: "Time" }, yaxis: { title: "Value" } }}
//     />
//   );
// };

const RiskAnalysis = ({ stockSymbol }) => {
  const [riskData, setRiskData] = useState(null);
  const subSections = ["Historical Volatility", "Beta & Correlation", "Drawdowns & Max Pain","Implied Volatility"];//, "Trends Treemap"];
  const [activeSubTab, setActiveSubTab] = useState(subSections[0]);

  useEffect(() => {
      fetchStockRiskVol(stockSymbol)
      .then((data) => setRiskData(data))
      .catch((error) => console.error("Error fetching Risk analysis:", error));
  }, [stockSymbol]);

  if (!riskData) return <p>Loading Risk analysis...</p>;

  const renderContent = () => {

    switch (activeSubTab) {
      case "Historical Volatility":
        return riskData ? (<div align={"center"} style={{height:"700px"}}>
      <HistoricalVol data={riskData} />
            </div>) : (
                <p>Loading data...</p>
              );
      case "Beta & Correlation":
        return riskData ? (<div align={"center"} style={{height:"700px"}}>
      <BetaCorr data={riskData} />
                </div>): (
                <p>Loading data...</p>
              );
      case "Drawdowns & Max Pain":
        return riskData ? (<div align={"center"} style={{height:"700px"}}>
      <Drawdowns data={riskData} />
                </div>) : (
                <p>Loading data...</p>
              );
      case "Implied Volatility":
        return riskData ? (<div align={"center"} style={{height:"700px"}}>
      <ImpVol data={riskData} />
        </div>) : (
                <p>Loading data...</p>
              );
      default:
        return <div>Select a tab to view content.</div>;
    }
  };


  return (
    <div className="section-container">
        {/* Vertical Sidebar */}
      <div className="sidebar">
        {subSections.map((tab) => (
          <button
            key={tab}
            className={`side-tab ${activeSubTab === tab ? "active" : ""}`}
            onClick={() => setActiveSubTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Content Display */}
      <div className="content">
        {/*<h2>{activeSubTab}</h2>*/}
        {/*<p>Displaying data for {activeSubTab}...</p>*/}
        {renderContent()}
      </div>
    </div>
  );
};

export default RiskAnalysis;
